import { TailSpin } from 'react-loader-spinner';

const Loader = () => (
  <div className="Loader">
    <TailSpin color="#00BFFF" height={80} width={80} />
  </div>
);

export default Loader;
